<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
  <div
    class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">

    <!-- Header -->
    <div class="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div class="flex items-center gap-4 px-5 py-4">
        <!-- Back button logic normally placed here -->
        <button
          class="h-10 w-10 grid place-items-center rounded-2xl hover:bg-slate-50 active:scale-95 transition-all text-slate-700">
          <span class="material-symbols-outlined text-slate-700">arrow_back</span>
        </button>
        <div class="flex-1">
          <h1 class="text-xl font-black text-slate-800 tracking-tight">{{ 'เลือกจำนวนห้องพัก' | translate : 'room-quantity' }}</h1>
          <p class="text-xs font-medium text-slate-500 mt-0.5">{{ 'ระบุจำนวนห้องและแพ็กเกจราคา' | translate : 'room-quantity' }}</p>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto w-full px-5 pt-5 pb-32 space-y-4">
      <div class="bg-blue-50/50 rounded-2xl p-4 border border-blue-100 flex items-center gap-4 shadow-sm">
        <div class="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center shrink-0">
          <span class="material-symbols-outlined text-blue-600" style="font-size:1.5rem">bed</span>
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-[15px] font-bold text-slate-800 leading-tight">{{ 'ห้องดีลักซ์เตียงใหญ่' | translate : 'room-quantity' }}</div>
          <div class="text-[12px] text-slate-500 mt-1">{{ 'จำนวนที่ต้องการเข้าพัก' | translate : 'room-quantity' }}</div>
        </div>
      </div>

      <div class="flex items-center justify-between gap-3 p-4 rounded-3xl border border-slate-100 bg-white shadow-sm">
        <div class="flex items-center gap-3">
          <span class="material-symbols-outlined text-slate-400">meeting_room</span>
          <div class="text-[15px] font-semibold text-slate-700">{{ 'จำนวนห้องพัก' | translate : 'room-quantity' }}</div>
        </div>

        <!-- Stepper -->
        <div
          class="flex items-center justify-between gap-2 w-[120px] bg-slate-50 rounded-2xl border border-slate-200 p-1.5 shadow-inner">
          <button
            class="w-9 h-9 flex items-center justify-center rounded-xl bg-white shadow-sm hover:shadow active:scale-95 text-slate-500 hover:text-blue-600 transition-all border border-slate-100">
            <span class="text-xl font-medium leading-none mb-0.5">−</span>
          </button>
          <div class="w-8 text-center text-base font-bold text-slate-800">2</div>
          <button
            class="w-9 h-9 flex items-center justify-center rounded-xl bg-white shadow-sm hover:shadow active:scale-95 text-slate-500 hover:text-blue-600 transition-all border border-slate-100">
            <span class="text-xl font-medium leading-none mb-0.5">+</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Bottom bar (sticky inside card) -->
    <div
      class="absolute bottom-0 inset-x-0 bg-white/80 backdrop-blur-md border-t border-slate-100 p-5 z-20 shadow-[0_-10px_30px_rgba(0,0,0,0.05)]">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
            <span class="material-symbols-outlined text-blue-500 text-[16px]">hotel</span>
          </div>
          <div>
            <div class="text-[13px] font-bold text-slate-800">{{ '{count} ห้อง' | translate : { module: 'room-quantity', count: 2 } }}</div>
            <div class="text-[11px] text-slate-400 font-medium">{{ 'ราคา {n} คืน' | translate : { module: 'room-quantity', n: 1 } }}</div>
          </div>
        </div>
        <div class="text-right">
          <div class="text-[11px] text-slate-400 font-medium uppercase tracking-wider mb-0.5">{{ 'รวมเป็นเงิน' | translate : 'room-quantity' }}</div>
          <div class="text-lg font-black text-slate-900 leading-none">3,000 <span
              class="text-xs font-bold text-slate-500">{{ 'บาท' | translate : 'room-quantity' }}</span></div>
        </div>
      </div>
      <button
        class="w-full rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 py-3.5 text-sm font-bold text-white hover:from-blue-700 hover:to-indigo-700 active:scale-[0.98] transition-all shadow-md shadow-blue-300">
        {{ 'ตกลง' | translate : 'room-quantity' }}
      </button>
    </div>
  </div>
</div>